import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

export enum FlightBadgeType {
  Green = 'green',
  Sun = 'sun',
}

@Component({
  selector: 'flight-badge',
  templateUrl: './flight-badge.component.html',
  styles: [':host { display: contents; }'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FlightBadgeComponent {
  @Input() title: string = '';
  @Input() icon: string = '';
  @Input() type: FlightBadgeType;
}
